import React, {createContext, useContext, useState, ReactNode} from 'react';
import { themes, ThemeType } from './themes';


type ThemeMode = keyof typeof themes;

type ThemeContextProps = {
  theme: ThemeType;
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
};

const ThemeContext = createContext<ThemeContextProps>({
  theme: themes.light,
  mode: 'light',
  setMode: () => {},
});

export const ThemeProvider = ({children}: {children: ReactNode}) => {
  const [mode, setMode] = useState<ThemeMode>('light');

  const value: ThemeContextProps = {
    theme: themes[mode],
    mode,
    setMode,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
